export const content = `
  Pricing page
`
